module.exports = __webpack_public_path__ + "img/feature_3.b27be93a.png";